import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { Reveal, LineReveal } from "@/components/Reveal";
import { BookingForm } from "@/components/BookingForm";

const Contact = () => (
  <div data-testid="contact-page" className="pt-32">
    <section className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <div className="grid lg:grid-cols-2 gap-16 items-start">
        <div>
          <Reveal>
            <p className="text-xs uppercase tracking-[0.3em] text-golden-500 font-semibold mb-6">Book a Call</p>
            <h1 className="font-serif text-white text-5xl md:text-7xl leading-[0.95] tracking-tight mb-8">
              <LineReveal lines={["Let's talk.", "No jargon."]} delay={0.2} />
            </h1>
            <p className="text-sage-300 text-lg leading-relaxed mb-10 max-w-md">
              Tell me a little about your situation and when you'd like to talk. I'll personally reach out to confirm a free discovery call, no pressure, no sales script.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="rounded-sm overflow-hidden border border-forest-700 mb-8">
              <img src="/generated/contact.png" onError={(e) => (e.currentTarget.src = "/generated/about.png")} alt="Alpine lake at sunrise" className="w-full h-64 object-cover" />
            </div>
            <ul className="space-y-4 text-sage-200">
              <li className="flex items-center gap-3"><MapPin className="h-5 w-5 text-golden-500" /> Oregon</li>
              <li className="flex items-center gap-3"><Mail className="h-5 w-5 text-golden-500" /> susan@cascadehradvisors.com</li>
              <li className="flex items-center gap-3"><Phone className="h-5 w-5 text-golden-500" /> By appointment</li>
            </ul>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <div className="bg-forest-900 border border-forest-700 rounded-sm p-8 lg:sticky lg:top-28">
            <h2 className="font-serif text-3xl text-sage-100 mb-6">Request your discovery call</h2>
            <BookingForm compact />
          </div>
        </Reveal>
      </div>
    </section>
  </div>
);

export default Contact;
